<template>
  <div class="component-weekdays">
    <label class="checkbox"
      v-for="(day, code) of weekdays" :key="code"
    >
      <input type="checkbox" v-model="selected" :value="code">
        {{ day }}
    </label>
  </div>
</template>
<script lang="ts">
import { weekdayKey, Weekdays } from '@/store/common.types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class WeekdaysInput extends Vue {
  @Prop() value!: weekdayKey[]

  private weekdays = Weekdays

  private get selected(): weekdayKey[] {
    return this.value
  }

  private set selected(weekdays: weekdayKey[]) {
    this.$emit('input', weekdays)
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
}

.component-weekdays {
  display:flex;
  flex-wrap: wrap;
}

.checkbox {
  display: block;
  width: 65px;
}
</style>
